import { render, staticRenderFns } from "./messages-subpage.vue?vue&type=template&id=312d2518&lang=pug&"
import script from "./messages-subpage.vue?vue&type=script&lang=js&"
export * from "./messages-subpage.vue?vue&type=script&lang=js&"
import style0 from "./messages-subpage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports